import PageHeader from "@/components/PageHeader";
import Reveal from "@/components/Reveal";
import { ButtonSecondary } from "@/components/Buttons";

export default function Legal({ title }) {
    return (
        <div data-testid={`legal-page-${title.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
            <PageHeader eyebrow="Legal" title={title} />
            <section className="pb-24 sm:pb-32 px-6 lg:px-8">
                <Reveal className="max-w-3xl">
                    <div className="border border-dashed border-gold/25 rounded-sm px-8 py-16 text-center">
                        <p className="font-serif text-2xl font-light text-brand">This document is being prepared.</p>
                        <p className="mt-4 text-sm leading-relaxed text-mist max-w-md mx-auto">
                            The full {title.toLowerCase()} will be published here. In the meantime, questions may be
                            directed to hello@grayhavenresearch.com.
                        </p>
                        <div className="mt-8">
                            <ButtonSecondary to="/contact" data-testid="legal-contact-btn">
                                Contact Grayhaven
                            </ButtonSecondary>
                        </div>
                    </div>
                </Reveal>
            </section>
        </div>
    );
}
